/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogEventEntity
 */
export interface LogEventEntity {
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof LogEventEntity
     */
    logStorageDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    logData?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    logDataSchemaVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    actionType?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    actorId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    patientId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    cardId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventEntity
     */
    cardTypeId?: string;
}

export function LogEventEntityFromJSON(json: any): LogEventEntity {
    return LogEventEntityFromJSONTyped(json, false);
}

export function LogEventEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogEventEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'logStorageDate': !exists(json, 'logStorageDate') ? undefined : (new Date(json['logStorageDate'])),
        'logData': !exists(json, 'logData') ? undefined : json['logData'],
        'logDataSchemaVersion': !exists(json, 'logDataSchemaVersion') ? undefined : json['logDataSchemaVersion'],
        'actionType': !exists(json, 'actionType') ? undefined : json['actionType'],
        'actorId': !exists(json, 'actorId') ? undefined : json['actorId'],
        'patientId': !exists(json, 'patientId') ? undefined : json['patientId'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'cardId': !exists(json, 'cardId') ? undefined : json['cardId'],
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
    };
}

export function LogEventEntityToJSON(value?: LogEventEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'logStorageDate': value.logStorageDate === undefined ? undefined : (value.logStorageDate.toISOString()),
        'logData': value.logData,
        'logDataSchemaVersion': value.logDataSchemaVersion,
        'actionType': value.actionType,
        'actorId': value.actorId,
        'patientId': value.patientId,
        'carePrincipalId': value.carePrincipalId,
        'cardId': value.cardId,
        'cardTypeId': value.cardTypeId,
    };
}

